/**
 * @file Contém enums referente ao Alert
 */
const variants = {
    SUCCESS: 'success',
    DANGER: 'danger',
    WARNING: 'warning'    
}
    
export default {variants};
